<template>
  <div class="box">
    <div class="doc-cont clearfix">
      <!-- 有文档数据 -->
      <div v-if="detailInfoData.function_name_cn" class="right-doc">
        <div class="docCons">
          <div class="docCons-title">
            <h2 class="one-title" style="margin-right: 10px;">
              {{ detailInfoData.function_name_cn }}
            </h2>
            <!-- <a href="javascript:;" @click="onlineTest">在线测试</a> -->
            <div class="info">
              <span style="margin-right: 5px;">更新时间</span>
              <span style="margin-right: 5px;">{{
                detailInfoData.modify_date
              }}</span>
              <span style="margin-right: 5px;">{{
                detailInfoData.modify_time
              }}</span>
            </div>
          </div>
          <div class="docCons-con">
            <div class="docCons-con-item">
              <h3 class="tow-title" style="margin-bottom: 8px">功能描述</h3>
              <p class="tow-con">{{ detailInfoData.description }}</p>
            </div>
            <div class="docCons-con-item">
              <h3 class="tow-title base-info">基本信息</h3>
              <!-- <el-table :data="baseData" style="width: 100%" row-key="api_param_id" border>
                <el-table-column :show-overflow-tooltip="true" prop="agree_type" label="协议类型"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="request_type" label="请求类型"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="version_no" label="版本"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="restful_uri" label="url"></el-table-column>
              </el-table>-->
              <div class="base-info-row">
                <span>接口名称：</span>
                <span>{{ detailInfoData.function_name }}</span>
              </div>
              <div class="base-info-row">
                <span>获取方式：</span>
                <span>HTTP({{ detailInfoData.request_type_str }})</span>
              </div>
              <div class="base-info-row">
                <span>API调用：</span>
                <span>
                  <a href="javascript:;" @click="toApiServer">API调用方法</a>
                </span>
              </div>
              <div class="base-info-row">
                <span>URL(sandbox)：</span>
                <span
                  >{{ LOCAL_CONFIG.sandboxUrl
                  }}{{ detailInfoData.restful_uri }}</span
                >
                <span v-if="online_test_flag == 1">
                  <a href="javascript:;" @click="onlineTest">去调试</a>
                </span>
              </div>
              <div class="base-info-row">
                <span>URL(prd)：</span>
                <span v-if="gateway"
                  >{{ LOCAL_CONFIG.prdUrl
                  }}{{ detailInfoData.restful_uri }}</span
                >
                <span v-else
                  >{{ gateway_url }}{{ detailInfoData.restful_uri }}</span
                >
              </div>
            </div>
            <div class="docCons-con-item" v-if="reqHeaderData&&reqHeaderData.length">
              <h3 class="tow-title">请求参数-header</h3>
              <div>
                <el-table
                  :data="reqHeaderData"
                  style="width: 100%"
                  row-key="api_param_id"
                  border
                  :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren'
                  }"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="field_name"
                    label="参数名"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="business_name"
                    label="参数类型"
                  ><template slot="header" slot-scope="scope">
                      参数类型
                      <el-tooltip :aa="scope" class="item" effect="dark"   placement="top-start">
                       <p slot="content" style="width:422px">恒生的标准化定义中，标准字段的数据类型分为字符C，字符串C，整数N和浮点数N，举例：C1表示字符，字符规定为1位；C200表示为字符串，长度为200；N64表示整数，长度为64位；N64.1表示浮点数，长度为64位，精度为1；</p>
                        <i class="el-icon-question" style="color: #606266"> </i>
                      </el-tooltip>
                    </template></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="name_cn"
                    label="说明"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dict_first_name"
                    label="数据字典"
                  >
                    <template slot-scope="scope">
                      <el-link @click="previewDict(scope.row)">{{
                        scope.row.dict_first_name
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_required"
                    label="必选项"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="default_value"
                    label="缺省值"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_collection"
                    label="集合"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="param_remark"
                    label="备注"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="docCons-con-item" v-if="reqQueryData&&reqQueryData.length">
              <h3 class="tow-title">请求参数-query</h3>
              <div>
                <el-table
                  :data="reqQueryData"
                  style="width: 100%"
                  row-key="api_param_id"
                  border
                  :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren'
                  }"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="field_name"
                    label="参数名"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="business_name"
                    label="参数类型"
                  ><template slot="header" slot-scope="scope">
                      参数类型
                      <el-tooltip :aa="scope" class="item" effect="dark"   placement="top-start">
                       <p slot="content" style="width:422px">恒生的标准化定义中，标准字段的数据类型分为字符C，字符串C，整数N和浮点数N，举例：C1表示字符，字符规定为1位；C200表示为字符串，长度为200；N64表示整数，长度为64位；N64.1表示浮点数，长度为64位，精度为1；</p>
                        <i class="el-icon-question" style="color: #606266"> </i>
                      </el-tooltip>
                    </template></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="name_cn"
                    label="说明"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dict_first_name"
                    label="数据字典"
                  >
                    <template slot-scope="scope">
                      <el-link @click="previewDict(scope.row)">{{
                        scope.row.dict_first_name
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_required"
                    label="必选项"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="default_value"
                    label="缺省值"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_collection"
                    label="集合"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="param_remark"
                    label="备注"
                  ></el-table-column>
                </el-table>
              </div>
            </div>

            <div class="docCons-con-item"  v-if="reqBodyData&&reqBodyData.length">
              <h3 class="tow-title">请求参数-body</h3>
              <div>
                <el-table
                  :data="reqBodyData"
                  style="width: 100%"
                  row-key="api_param_id"
                  border
                  :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren'
                  }"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="field_name"
                    label="参数名"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="business_name"
                    label="参数类型"
                  ><template slot="header" slot-scope="scope">
                      参数类型
                      <el-tooltip :aa="scope" class="item" effect="dark"   placement="top-start">
                       <p slot="content" style="width:422px">恒生的标准化定义中，标准字段的数据类型分为字符C，字符串C，整数N和浮点数N，举例：C1表示字符，字符规定为1位；C200表示为字符串，长度为200；N64表示整数，长度为64位；N64.1表示浮点数，长度为64位，精度为1；</p>
                        <i class="el-icon-question" style="color: #606266"> </i>
                      </el-tooltip>
                    </template></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="name_cn"
                    label="说明"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dict_first_name"
                    label="数据字典"
                  >
                    <template slot-scope="scope">
                      <el-link @click="previewDict(scope.row)">{{
                        scope.row.dict_first_name
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_required"
                    label="必选项"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="default_value"
                    label="缺省值"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_collection"
                    label="集合"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="param_remark"
                    label="备注"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="docCons-con-item"  v-if="ansParamsData&&ansParamsData.length">
              <h3 class="tow-title">响应参数</h3>
              <div>
                <el-table
                  :data="ansParamsData"
                  style="width: 100%"
                  row-key="api_param_id"
                  border
                  :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren'
                  }"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="field_name"
                    label="参数名"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="business_name"
                    label="参数类型"
                  ><template slot="header" slot-scope="scope">
                      参数类型
                      <el-tooltip :aa="scope" class="item" effect="dark"   placement="top-start">
                       <p slot="content" style="width:422px">恒生的标准化定义中，标准字段的数据类型分为字符C，字符串C，整数N和浮点数N，举例：C1表示字符，字符规定为1位；C200表示为字符串，长度为200；N64表示整数，长度为64位；N64.1表示浮点数，长度为64位，精度为1；</p>
                        <i class="el-icon-question" style="color: #606266"> </i>
                      </el-tooltip>
                    </template></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="name_cn"
                    label="说明"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dict_first_name"
                    label="数据字典"
                  >
                    <template slot-scope="scope">
                      <el-link @click="previewDict(scope.row)">{{
                        scope.row.dict_first_name
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_required"
                    label="必选项"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="default_value"
                    label="缺省值"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="is_collection"
                    label="集合"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="param_remark"
                    label="备注"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="docCons-con-item">
              <h3 class="tow-title">请求示例</h3>
              <div class="demoBox">
                <json-viewer
                  id="tar_text1"
                  copyable
                  :expand-depth="5"
                  :value="reqJsonData"
                >
                  <div
                    slot="copy"
                    class="copy-icon iconfont icon-ios-copy-outline"
                  ></div>
                </json-viewer>
              </div>
            </div>
            <div class="docCons-con-item" >
              <h3 class="tow-title">返回示例</h3>
              <div>
                <h-tabs type="card">
                  <h-tab-pane label="json">
                    <div class="demoBox">
                      <json-viewer
                        id="tar_text2"
                        copyable
                        :expand-depth="5"
                        :value="ansJsonData"
                      >
                        <div
                          slot="copy"
                          class="copy-icon iconfont icon-ios-copy-outline"
                        ></div>
                      </json-viewer>
                    </div>
                  </h-tab-pane>
                </h-tabs>
              </div>
            </div>
            <div class="docCons-con-item" v-if="errorCodeData&&errorCodeData.length">
              <h3 class="tow-title">错误码</h3>
              <div>
                <el-table
                  :data="errorCodeData"
                  style="width: 100%"
                  row-key="api_param_id"
                  border
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="error_no"
                    label="错误码"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="error_info"
                    label="错误信息"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="error_message"
                    label="描述"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="docCons-con-item">
              <h3 class="tow-title">错误应答示例</h3>
              <div>
                <div>
                  <h-tabs type="card">
                    <h-tab-pane label="json">
                      <div class="demoBox">
                        <json-viewer
                          id="tar_text3"
                          copyable
                          :expand-depth="5"
                          :value="errorJsonData"
                        >
                          <div
                            slot="copy"
                            class="copy-icon iconfont icon-ios-copy-outline"
                          ></div>
                        </json-viewer>
                      </div>
                    </h-tab-pane>
                  </h-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 无文档数据 -->
      <div v-else-if="loaded" class="right-doc api-no-result">
        <img src="@/assets/doc/search-no.png" />
        <p>请选择文档，查看具体内容！</p>
      </div>
       <div v-else class="right-doc api-no-result">
        <img src="@/assets/course/course_loading_pic.png" />
        <p>正在加载中...</p>
      </div>
      <div id="left-tree">
        <h-input icon="search" @on-change="handleApiDocChange"></h-input>
        <div ref="tree-content" v-if="treeLoaded">
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="api_id"
            :default-expanded-keys="expandList"
            :expand-on-click-node="true"
            :default-expand-all="true"
            :highlight-current="true"
            :props="{ label: 'api_name', children: 'api_infos' }"
            @node-click="nodeClick"
          >
            <div slot-scope="{ data }" class="custom-tree-node">
              <template>
                <a
                  class="tree-item-title"
                  style="color:#606266"
                  :title="data.api_group_name|| data.api_name"
                >{{ data.api_group_name || data.api_name}}</a>
              </template>
            </div>
          </el-tree>
        </div>
        <div v-else>
          加载中...
        </div>
      </div>
    </div>
    <!-- 数据字典项弹框 -->
    <h-msg-box
      width="350"
      v-model="dictShow"
      :escClose="true"
      :footerHide="true"
    >
      <h-table
        :columns="dictColumns"
        :data="dictData"
        size="small"
        :showTitle="true"
      ></h-table>
    </h-msg-box>
  </div>
</template>
<script>
import { Icon,Tree,Table,TableColumn,Link,Tooltip } from "element-ui";
// import '@/style/views/doc.scss';
import {
  getDetail,
  getServieDetailApiGroups,
  getSearchSubEntryDoc
} from "@/api/frontDoc/api";
// import Clipboard from "clipboard";

function filtersText(val){
  if (val != null && val !== '') {
    return val.replace(/<[^>]+>/g, '').replaceAll('&nbsp;', '').replaceAll('&ldquo;','"').replaceAll('&rdquo;','"');
  } else return '';
}
function safeToJSON(jsonStr){
  try {
    return JSON.parse(jsonStr);
  }catch (error){
    return jsonStr;
  }
}

export default {
  name: "ApiDoc",
  props: {
    serviceId: "",
    serviceName: ""
  },
  data() {
    return {
      treeLoaded:false,//左侧目录加载完成
      loaded:false,//文档加载完成
      apisList: [], //左侧目录
      currentApiId: "",
      reqJsonData: {},
      ansJsonData: {},
      errorJsonData: {},
      detailInfoData: {},
      treeData: [], // 目录树
      scroll: "",
      // activeName: "tab0", // 锚点选中项
      navList: [], // 锚点内容
      domFixed: false, // 锚点悬浮框是否悬浮
      expandList: [], // 目录节点默认展开数组，node的api_group_id
      docTitleList: [], // 文档选择目录路径，内容为路径名称 报错文档名称
      tabPosition: "right", // 锚点位置
      apiList: [],
      baseData: [
        {
          agree_type: "",
          request_type: "",
          version_no: "",
          restful_uri: ""
        }
      ],
      reqHeaderData: [],
      reqQueryData: [],
      reqBodyData: [],
      ansParamsData: [],
      errorCodeData: [],
      dataFixed: [
        {
          address_url: "https://vopen.hscloud.cn",
          address_name_cn: "仿真交易类生产调用地址；"
        },
        {
          address_url: "https://api.hscloud.cn",
          address_name_cn: "数据核查类生产调用地址"
        },
        {
          address_url: "https://open.hscloud.cn",
          address_name_cn: "其余生产调用地址"
        }
      ],
      dictShow: false,
      dictColumns: [
        {
          title: "字典名称",
          key: "subentry_name",
          ellipsis: true
        },
        {
          title: "字典子项",
          key: "subentry",
          ellipsis: true
        }
      ],
      dictData: [],
      toOnlineTest: {
        service_id: "",
        api_id: ""
      },
      online_test_flag: 1,
      gateway_url: null
      // gateway: true
    };
  },
  watch: {
    $route() {
      this.initPage();
    }
  },
  components: {
    Icon:Icon,
    elTree: Tree,
    elTable:Table,
    elTableColumn:TableColumn,
    elLink:Link,
    elTooltip:Tooltip
  },
  computed: {
    gateway() {
      return this.gateway_url == null || this.gateway_url.trim() == "";
    }
  },
  destroyed() {},
  mounted() {
    this.initPage();
  },
  methods: {
    /*
    在线测试 去调用
    */
    onlineTest() {
      window.location.href = `/openplat-doc/onlineTest?service_id=${this.toOnlineTest.service_id}&api_id=${this.toOnlineTest.api_id}`;
    },
    // 点击API调用连接
    toApiServer() {
      window.open("/openplat-doc/gtnDoc?doc_id=" + 1);
    },
    previewDict(row) {
      if (row.dict_first_name !== "--" && row.dict_first_name !== "") {
        getSearchSubEntryDoc({
          key: "",
          dict_entry_id: row.dict_entry_id,
          operator_code: "admin"
        }).then(res => {
          this.dictShow = true;
          this.dictData = res;
        });
      } else {
        this.dictShow = false;
      }
    },

    handleClick(tab) {
      this.jump(tab.index);
    },
    dataScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    jump(index) {
      const container = document.querySelector(".right-doc");
      const jump = container.querySelectorAll("h1,h3,h4,h5,h6");
      // 获取需要滚动的距离
      // let total = jump[index].offsetTop - 50;
      const total = jump[index].offsetTop;
      // const maxHeight = document.body.clientHeight - window.innerHeight - 50
      // if (total > maxHeight) {
      //   total = maxHeight
      // }
      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },

    /**
     * 获取所有标题 设置右侧导航
    //  */
    // selectAllTitle() {
    //   const container = document.querySelector(".right-doc");
    //   const title = container.querySelectorAll("h1,h3,h4,h5,h6");
    //   this.navList = Array.from(title);
    //   this.navList.forEach(item => {
    //     item.name = item.innerHTML.replace(/<[^>]+>/g, "");
    //   });
    //   this.navList.forEach(el => {
    //     const index = el.localName.indexOf("h");
    //     el.lev = `lev${el.localName.substring(index + 1, el.localName.length)}`;
    //   });
    //   setTimeout(() => {
    //     const navs = document.querySelectorAll(".el-tabs__item");
    //     for (let i = navs.length - 1; i >= 0; i--) {
    //       // 导航从h1到h5分别添加不同到样式
    //       document.querySelector(`#${navs[i].id}`).style.padding = "0";
    //       if (this.navList[i].lev == "lev1") {
    //         document.querySelector(`#${navs[i].id}`).style.paddingLeft = "20px";
    //       } else if (this.navList[i].lev == "lev2") {
    //         document.querySelector(`#${navs[i].id}`).style.paddingLeft = "35px";
    //       } else if (this.navList[i].lev == "lev3") {
    //         document.querySelector(`#${navs[i].id}`).style.paddingLeft = "50px";
    //       } else if (this.navList[i].lev == "lev4") {
    //         document.querySelector(`#${navs[i].id}`).style.paddingLeft = "65px";
    //         document.querySelector(`#${navs[i].id}`).style.fontWeight = "400";
    //       } else if (this.navList[i].lev == "lev5") {
    //         document.querySelector(`#${navs[i].id}`).style.paddingLeft = "80px";
    //         document.querySelector(`#${navs[i].id}`).style.fontWeight = "400";
    //       }
    //     }
    //   });
    // },
    getSelectplace() {
      let leftTreeHeight = document.querySelector("#left-tree").clientHeight;
      let x = document.querySelector(".is-current").offsetTop;
      if (x + 456 > leftTreeHeight) {
        this.$refs["tree-content"].scrollTop =
          x - leftTreeHeight + (leftTreeHeight * 2) / 3 + 76;
        // let y = - (x - leftTreeHeight + leftTreeHeight * 2 / 3 + 76)
        // this.$refs['tree-content'].scrollBy(0, y)
      }
    },
    nodeClick(data) {
      this.loaded = false;
      this.toOnlineTest = {
        service_id: data.api_group_id,
        api_id: data.api_id
      };
      if (data.api_id) {
        getDetail({
          api_id: data.api_id,
          operator_code: "admin"
        }).then(res => {
          this.loaded = true;
          this.detailInfoData = res;
          try {
            let date = res.modify_date;
            this.detailInfoData.modify_date = /(\d{4})(\d{2})(\d{2})/
              .exec(date)
              .slice(1, 4)
              .join("-");
            let time = res.modify_time;
            this.detailInfoData.modify_time = /(\d{2})(\d{2})(\d{2})/
              .exec(time)
              .slice(1, 4)
              .join(":");
            this.detailInfoData.request_type_str = this.detailInfoData.request_type.join(
              "/"
            );
          } catch (error) {
            this.detailInfoData.modify_date = "";
            this.detailInfoData.modify_time = "";
          }
          function getParams(list, arr) {
            function iter(data, id) {
              for (let i = 0; i < data.length; i++) {
                data[i].is_collection =
                  parseInt(data[i].is_collection, 10) === 1 ? "是" : "否";
                data[i].is_required =
                  parseInt(data[i].is_required, 10) === 1 ? "是" : "否";
                data[i].name_cn = data[i].name_cn.trim() || "--";
                data[i].dict_first_name =
                  data[i].dict_first_name.trim() || "--";
                data[i].default_value = data[i].default_value.trim() || "--";
                // data[i].id = data[i].id + (i + 1) - 0
                data[i].id = data[i].id + (i + 1) - 0;
                if (data[i].children && data[i].children.length > 0) {
                  iter(data[i].children, data[i].id);
                }
              }
            }
            iter(list, "");
            return list;
          }
          this.gateway_url = res.gateway_url;
          this.online_test_flag = res.online_test_flag;
          if (res.ans_body && res.ans_body.length > 0) {
            this.ansParamsData = getParams(res.ans_body, []);
          }

          this.reqHeaderData = getParams(res.req_header, []);
          this.reqQueryData = getParams(res.req_query, []);
          this.reqBodyData = getParams(res.req_body, []);

          this.baseData[0].agree_type =
            this.detailInfoData.agree_type === "2"
              ? "HTTP"
              : this.detailInfoData.agree_type === "1"
              ? "T3"
              : "T2";
          this.baseData[0].request_type = this.detailInfoData.request_type.join(
            ","
          );
          this.baseData[0].version_no = this.detailInfoData.version_no;
          this.baseData[0].restful_uri = this.detailInfoData.restful_uri;

          this.reqJsonData = res.req_demo.trim()
            ? safeToJSON(filtersText(decodeURIComponent(res.req_demo))):
            '暂无数据';
          this.ansJsonData = res.ans_demo.trim()
            ? safeToJSON(filtersText(decodeURIComponent(res.ans_demo)))
            : "暂无数据";
          this.errorJsonData = res.error_ans_demo.trim()
            ? safeToJSON(filtersText(decodeURIComponent(res.error_ans_demo)))
            : "暂无数据";
          this.errorCodeData = res.error_infos;
          // 获取文档路径
          this.expandTree(data.api_group_id);
          // this.detailInfoData.function_name_cn = data.function_name_cn;
          this.detailInfoData.api_name = data.api_name;
          this.$nextTick(() => {
            this.getSelectplace();
          });
          // 设置当前页面url 不跳转
          const url = `${window.location.href.split("?")[0]}?apiId=${
            data.api_id
          }`;
          history.replaceState(null, null, url);
        },()=>{
          this.loaded = false
        });
      }

      const that = this;
      // 减少接口请求 非叶节点不查询
      if (data.children && data.children.length > 0) {
        return;
      }
      const parms = {
        api_id: "",
        operator_code: "admin"
      };
      // getDetail(parms).then(res => {
      //   // 获取文档路径
      //   that.expandTree(data.api_group_id);
      //   // 文档类型为连接 打开新页面
      //   if (res.doc_type === '0') {
      //     window.open(res.link_url);
      //   } else if (res.doc_type === '1') {
      //     that.docItem = res;
      //     that.docItem.api_group_name = data.api_group_name;
      //     that.$nextTick(() => {
      //       that.selectAllTitle();
      //     });
      //     // 设置当前页面url 不跳转
      //     const url = `${window.location.href.split('?')[0]}?docId=${data.api_group_id}`;
      //     history.replaceState(null, null, url);
      //   }
      // });
    },

    GetQueryString(param) {
      //param为要获取的参数名 注:获取不到是为null
      let currentUrl = window.location.href; //获取当前链接
      let arr = currentUrl.split("?"); //分割域名和参数界限
      if (arr.length > 1) {
        arr = arr[1].split("&"); //分割参数
        for (let i = 0; i < arr.length; i++) {
          let tem = arr[i].split("="); //分割参数名和参数内容
          if (tem[0] === param) {
            return tem[1];
          }
        }
        return null;
      } else {
        return null;
      }
    },
    //获取左侧目录
    getListFun(doc_content) {
      const that = this;
      this.treeLoaded = false
      return new Promise(resolve => {
        getServieDetailApiGroups({
          service_id: this.serviceId,
          doc_content: doc_content || ''
        }).then(res => {
          this.treeLoaded = true
          if (res.error_no == 0) {
            this.treeData = res.service_infos;
          }
          resolve(res.service_infos);
        },()=>{
          this.treeLoaded = true
        });
      });
    },
    /** 根据docId
     * 查询tree 设置默认tree展开  设置默认选中tree
     * 默认显示文档
     * */
    async initPage(doc_content) {
      const list = await this.getListFun(doc_content);
      let defaultApiIds = "";
      list.forEach(item => {
        if (item.api_infos && item.api_infos.length > 0) {
          defaultApiIds = item.api_infos[0]
        }
        // debugger
        this.$nextTick(()=>{
           this.$refs.tree.setCurrentKey(defaultApiIds.api_id); // 默认选中tree
        })

        this.nodeClick(defaultApiIds);
      });
      // this.nodeClick(this.apisList[0]);
    },
    getFirstNode(list) {
      if (list.data && list.data.length > 0) {
        if (list.data[0].children) {
          return this.getFirstNode(list.data[0].children);
        } else {
          return list[0].api_group_id;
        }
      }

      // return list[0].api_group_id;
    },
    // 根据docId查找doc路径(返回数组为tree数组中doc所在位置)
    getPathById(id, catalog) {
      const temppath = [];
      const temppathTitlt = [];
      try {
        function getNodePath(node) {
          temppath.push(node.id);
          temppathTitlt.push(node.api_group_name);
          if (node.id === id) {
            // 找到符合条件的节点，通过throw终止掉递归
            throw "GOT IT!";
          }
          if (node.children && node.children.length > 0) {
            for (let i = 0; i < node.children.length; i++) {
              getNodePath(node.children[i], i);
            }
            // 当前节点的子节点遍历完依旧没找到，则删除路径中的该节点
            temppath.pop();
            temppathTitlt.pop();
          } else {
            // 找到叶子节点时，删除路径当中的该叶子节点
            temppath.pop();
            temppathTitlt.pop();
          }
        }
        getNodePath(catalog);
      } catch (e) {
        this.docTitleList = temppathTitlt;
        this.expandList = temppath;
      }
    },
    expandTree(faqId) {
      for (let i = 0; i < this.treeData.length; i++) {
        this.getPathById(faqId, this.treeData[i]);
      }
    },
    handleApiDocChange: _.debounce(function (event) {
      const queryKey = event.target.value
      this.initPage(queryKey)
    }, 300)
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #0ae !important;

  a {
    color: #fff !important;
  }
}
.doc-cont {
  margin: 0 auto;
  padding-bottom: 32px;
  // padding-top: 32px;
  background: #fff;
}
.right-doc {
  width: 100%;
  float: left;
  padding: 0 32px 0 32px;
  padding-left:220px;
}
#left-tree {
  width: 200px;
  position: sticky;
  top: 32px;
  float: left;
  margin-left: -100%;
  padding: 0 30px 0 10px;
  border: none;
  border-right: 1px solid #e5e7eb;
  height: calc(100vh - 252px);
  overflow: auto;
  flex-shrink: 0;
  scroll-behavior: smooth;
  box-sizing: border-box;
}

::v-deep .el-table th.el-table__cell {
  background-color: #f6f7fc;
  font-size: 14px;
}
::v-deep .el-table {
  color: #666;
}

::v-deep .el-table thead {
  color: #333;
}
::v-deep .el-tabs__item {
  color: #999;
}
::v-deep .el-tabs__item.is-active {
  color: #409eff;
}
::v-deep .el-link {
  color: #409eff;
}
// ::v-deep .h-table th {
//   background-color: #f6f7fc;
//   font-size: 14px;
//   color: #333;
// }
// ::v-deep .h-table td {
//   font-size: 14px;
//   color: #666;
// }
.fixedStyle {
  position: fixed;
  top: 43px;
}
/deep/ .jv-light {
  background-color: #f6f7fc;
  border: 1px solid #cfd2e1;
}
.copy-icon {
  color: #666;
}
.absolute {
  position: absolute;
  top: 50px;
  left: 0;
}
.color-666 {
  color: #666;
}
.box {
  font-size: 12px;
  letter-spacing: 1px;
  color: #333;
}
.custom-tree-node,
.tree-item-title {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.right-doc {
  .content {
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f6f7fc;
    padding: 16px;
    text-align: center;
  }
  .docCons-title {
    h2 {
      display: inline-block;
      font-size: 24px;
      margin-bottom: 10px;
    }
    .info {
      color: #999;
    }
  }
  .demoBox {
    position: relative;
    .icon-ios-copy-outline {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
  }
  .docCons-con {
    .docCons-con-item {
      .base-info-row {
        margin-bottom: 8px;
      }
      h3 {
        margin: 32px 0 0 0;
      }
      p {
        color: #666666;
      }
      .tow-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      .base-info-item {
        color: #666666;
        .tow-title-item {
          display: inline-block;
          width: 30%;
        }
      }
    }
  }
}
.api-no-result{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  min-height: 300px;
  height: 100%;
  text-align: center;
  img {
    width: 612px;
    height: 265px;
  }
}

</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/apiDoc.vue